import type { PropsWithChildren } from "react";

import { graphql, useFragment } from "react-relay";

import { PageWithBreadCrumbs } from "app/components/layout/PageWithBreadCrumbs";
import { useNotificationsBreadcrumbs } from "app/hooks/routing/useNotificationsBreadcrumbs";

import type { NotificationsSettingsPage_query$key } from "./__generated__/NotificationsSettingsPage_query.graphql";
import type { BreadCrumbElement } from "app/components/BreadCrumbsHeader";

interface Props extends PropsWithChildren {
  queryRef: NotificationsSettingsPage_query$key;
  title: string;
  additionalCrumbs?: BreadCrumbElement[];
  withPaper?: boolean;
  /** Whether the layout renders `title` as the page heading (H2). Disable for pages that render their own header. */
  withHeader?: boolean;
}

export function NotificationsSettingsPage({
  queryRef,
  title,
  additionalCrumbs,
  children,
  withPaper = true,
  withHeader = true,
}: Props) {
  const data = useFragment(
    graphql`
      fragment NotificationsSettingsPage_query on Query {
        ...PageWithBreadCrumbs_query
      }
    `,
    queryRef,
  );

  const notificationsBreadcrumbs = useNotificationsBreadcrumbs();
  const breadcrumbs = [
    ...notificationsBreadcrumbs,
    ...(additionalCrumbs ?? []),
  ];

  return (
    <PageWithBreadCrumbs
      breadcrumbs={breadcrumbs}
      defaultTitle="Notifications"
      heading={withHeader ? title : undefined}
      queryRef={data}
      title={title}
      withPaper={withPaper}
    >
      {children}
    </PageWithBreadCrumbs>
  );
}
